export class Tipo {

    constructor(item: Tipo|void) {
        if(item instanceof Object) {
            this.key = item.key;
            this.name = item.name;
        }
    }

    key: string = "";
    name: string = "";
    public toString() {
        return this.name;
    }
}
